<div>
    <div [hidden]="isShowDoc">
        <form class="m-0 p-0" [formGroup]="templateForm" (ngSubmit)="crateTemplate()">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="card h-100 shadow-sm">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="d-flex align-items-center justify-content-between">

                                    <div class="d-flex align-items-center gap-2">
                                        <button type="button" class="btn btn-outline-secondary btn-sm"
                                            (click)="navigateBack()">
                                            ←
                                        </button>
                                        <h5 class="card-title mb-0 fw-semibold">
                                            {{isEditTemp ? 'Edit':'Add New'}} Template
                                        </h5>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <div class="mb-2">
                                    <label class="form-label" for="template-name">
                                        Template Name
                                    </label>
                                    <input type="text" class="form-control" id="template-name"
                                        placeholder="Template name" formControlName="name">
                                    <small class="text-danger"
                                        *ngIf="templateForm.get('name').touched && templateForm.get('name').hasError('required')">
                                        Template name is required.
                                    </small>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="mb-2">
                                    <label class="form-label" for="template-category">
                                        Category
                                    </label>

                                    <select class="form-select" id="template-category" formControlName="category">
                                        <option value="" disabled selected>
                                            Select template category
                                        </option>
                                        @for(category of categories; track category){
                                        <option [value]="category">{{category}}</option>
                                        }
                                    </select>
                                    <small class="text-danger"
                                        *ngIf="templateForm.get('category').touched && templateForm.get('category').hasError('required')">
                                        Category is required.
                                    </small>
                                </div>

                            </div>
                        </div>

                        <div class="row">
                            @if(!isEditTemp){
                            <div class="col-6">
                                <div class="mb-2">
                                    <label class="form-label fw-semibold">Upload Template Document</label>
                                    <div>
                                        <input type="file" accept="application/pdf" class="form-control form-control-sm"
                                            (change)="onFileSelect($event)" #fileInput />

                                        <div class="text-muted small mt-1">
                                            Only PDF files are supported. Max file size: 1MB.
                                        </div>

                                        <div *ngIf="selectedFile" class="text-success small mt-1">
                                            ✔ {{ selectedFile.name }}
                                        </div>

                                        <div *ngIf="!selectedFile && template?.fileUrl" class="text-success small mt-1">
                                            ✔ Existing file attached
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            <div class="col-6">
                                <div class="mb-2">
                                    <label class="form-label" for="template-description">
                                        Description
                                    </label>
                                    <textarea type="text" class="form-control" id="template-description"
                                        placeholder="Template description" formControlName="description"
                                        maxlength="250">
                                </textarea>
                                    <small class="text-muted">
                                        {{ templateForm.get('description').value?.length || 0 }}/250 characters
                                    </small>
                                </div>
                            </div>
                        </div>
                        @if(selectedFile){
                        <div class="mt-4">
                            <div class="row align-items-center mb-2">
                                <div class="col-6">
                                    <h6 class="fw-semibold mb-0">Recipients / Signers</h6>
                                </div>
                                <div class="col-6 text-end">
                                    <button class="btn btn-outline-primary btn-sm" type="button" (click)="addSigner()"
                                        [disabled]="signerList.length >= 5">
                                        + Add Signer
                                    </button>
                                </div>
                            </div>

                            <div *ngFor="let signer of signerList; let i = index" class="mb-2">
                                <div class="d-flex align-items-center justify-content-between border rounded p-2">

                                    <div class="fw-medium">
                                        Signer {{ i + 1 }}
                                    </div>

                                    <div class="d-flex gap-2">
                                        <button class="btn btn-outline-secondary btn-sm" type="button"
                                            (click)="signDoc(i)">
                                            Sign Document
                                        </button>
                                        @if(signerList.length !== 1){
                                        <button type="button" class="btn btn-outline-danger btn-sm"
                                            (click)="removeSigner(i)">
                                            ✕
                                        </button>
                                        }


                                    </div>

                                </div>
                            </div>

                            <small *ngIf="signerList.length >= 5" class="text-danger d-block mt-2">
                                You can add up to 5 recipients
                            </small>
                        </div>
                        }

                        <div class="row my-3">
                            <div class="col-12 text-center">
                                <app-validation-message class="text-start" [messages]="validationSummary"
                                    [dismissible]="true" (dismissed)="validationSummary = []">
                                </app-validation-message>
                                <button class="btn btn-primary" type="submit"
                                    [disabled]="loading">
                                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"
                                        aria-hidden="true"></span>
                                    {{loading ? 'Loading...' : (isEditTemp ? 'Update' : 'Submit')}}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </form>
    </div>

    @if(isShowDoc){
    <div [hidden]="!isShowDoc">
        <app-pdf-signer [signData]="signData" (close)="close($event)">
        </app-pdf-signer>
    </div>
    }
</div>
